var EditCarouselRequestModel = /** @class */ (function () {
    function EditCarouselRequestModel() {
    }
    return EditCarouselRequestModel;
}());
export { EditCarouselRequestModel };
